const warehousePhotos = [
  {
    url: "https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/e9271620-48b9-41e2-8361-ea0e6b08f56d_20260407_135020.jpg?v=30f5b8e9d778127292664d906644e72a",
    alt: "Hangzhou YAXIN warehouse shelves — Shell HK distributor auto parts storage",
    label: "Склад Ханчжоу",
    sub: "Зона хранения BMW/VAG",
    location: "YAXIN LIANPEI · Ханчжоу",
  },
  {
    url: "https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/158a7fd6-59d8-4808-b887-784ebc86ea40_20260407_141439.jpg?v=cfdaecfd467d93f41a40266612d15bb5",
    alt: "Guangzhou Chirun logistics hub warehouse — auto parts export China",
    label: "Склад Гуанчжоу",
    sub: "Guangzhou Chirun Logistics",
    location: "CHIRUN · Гуанчжоу",
  },
  {
    url: "https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/3d99f92e-ea60-4382-9981-5e40f187d303_20260407_141620.jpg?v=5a5ea3d47ca19d971596606bf4ca499d",
    alt: "YAXIN warehouse organized shelving system — Hangzhou YAXIN warehouse auto parts",
    label: "Система хранения",
    sub: "Организованная логистика",
    location: "YAXIN · Стеллажная система",
  },
  {
    url: "https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/a3ebdba5-3852-4b01-ad7c-45d5b27ef612_20260407_142414.jpg?v=bb660b378fb652b9ce60342daad0e4e6",
    alt: "Guangzhou Chirun logistics hub bulk storage — Shell HK distributor warehouse",
    label: "Зона комплектации",
    sub: "Отгрузка и упаковка",
    location: "CHIRUN · Зона отгрузки",
  },
];

const capabilities = [
  {
    icon: "ri-stack-line",
    value: "10 000+",
    unit: "SKU",
    title: "Постоянный запас",
    desc: "Готовность к отгрузке в течение 24 часов по BMW, Mercedes-Benz, VAG Group и JLR.",
  },
  {
    icon: "ri-building-4-line",
    value: "5 000",
    unit: "м²",
    title: "Складская площадь",
    desc: "Гуанчжоу (Guangzhou Chirun) + Ханчжоу (YAXIN LIANPEI). Два физических объекта.",
  },
  {
    icon: "ri-shield-check-line",
    value: "100%",
    unit: "",
    title: "Аудит качества",
    desc: "Каждая партия проходит визуальный и технический контроль перед отгрузкой.",
  },
  {
    icon: "ri-qr-code-line",
    value: "EAC",
    unit: "+ ЧЗ",
    title: "Маркировка на месте",
    desc: "Честный ЗНАК и EAC наносятся в Гуанчжоу/Нинбо до пересечения границы.",
  },
];

export default function SupplyChainSection() {
  return (
    <div id="supply-chain">

      {/* ── БЛОК 1: Заголовок — чистый тёмный фон, много воздуха ── */}
      <section className="bg-[#040810] pt-32 pb-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Физическая инфраструктура · КНР</span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end">
            <div>
              <h2 className="text-white leading-none mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(42px, 6vw, 80px)", letterSpacing: "0.03em" }}>
                СИЛА ЦЕПОЧКИ<br />
                ПОСТАВОК:<br />
                <span className="text-[#C9A84C]">РЕАЛЬНЫЙ СКЛАД —<br />РЕАЛЬНЫЙ ТОВАР</span>
              </h2>
            </div>
            <div className="pb-2">
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                Не посредник, не брокер — <strong className="text-white">физический склад</strong> в Гуанчжоу и Ханчжоу. Стеллажи с реальным товаром, готовым к отгрузке прямо сейчас.
              </p>
              <p className="text-gray-500 text-base leading-relaxed">
                Это и есть наше главное конкурентное преимущество перед любым торговым посредником: вы видите товар до оплаты, получаете POP-отчёт и знаете точный адрес склада.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── БЛОК 2: Большое фото на всю ширину — главный склад ── */}
      <section className="bg-[#040810] pb-4">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="relative overflow-hidden rounded-sm" style={{ height: "520px" }}>
            <img
              src="https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/1b4dada2-d45c-4c86-bd48-762f651538a9_20260407_135636.jpg?v=0d098e20e011b81d83f15adfdb972297"
              alt="Hangzhou YAXIN warehouse — Guangzhou Chirun logistics hub real warehouse photo"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#040810]/80 via-[#040810]/20 to-transparent"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-[#040810]/60 via-transparent to-transparent"></div>
            {/* Corner accents */}
            <div className="absolute top-6 left-6 w-10 h-10 border-t-2 border-l-2 border-[#C9A84C]/70"></div>
            <div className="absolute top-6 right-6 w-10 h-10 border-t-2 border-r-2 border-[#C9A84C]/70"></div>
            <div className="absolute bottom-6 left-6 w-10 h-10 border-b-2 border-l-2 border-[#C9A84C]/70"></div>
            <div className="absolute bottom-6 right-6 w-10 h-10 border-b-2 border-r-2 border-[#C9A84C]/70"></div>
            {/* Label */}
            <div className="absolute bottom-8 left-10">
              <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.3em] uppercase mb-2">Реальный склад · Наш объект</div>
              <div className="text-white font-black" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(24px, 3vw, 40px)", letterSpacing: "0.04em" }}>
                GUANGZHOU CHIRUN · ЭКСПОРТНЫЙ ХАБ
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── БЛОК 3: Сетка 4 фото — каждое с подписью ── */}
      <section className="bg-[#040810] py-4">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {warehousePhotos.map((photo) => (
              <div key={photo.label} className="relative overflow-hidden rounded-sm group" style={{ height: "320px" }}>
                <img
                  src={photo.url}
                  alt={photo.alt}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#040810] via-[#040810]/40 to-transparent"></div>
                <div className="absolute top-4 left-4 w-6 h-6 border-t-2 border-l-2 border-[#C9A84C]/50"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="text-[#C9A84C] text-[9px] font-semibold tracking-[0.25em] uppercase mb-1">{photo.location}</div>
                  <div className="text-white text-sm font-bold mb-0.5">{photo.label}</div>
                  <div className="text-gray-500 text-xs">{photo.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── БЛОК 4: Цифры — широкие карточки с воздухом ── */}
      <section className="bg-[#040810] py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-14">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Ключевые показатели</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {capabilities.map((cap) => (
              <div key={cap.title} className="bg-[#0A0F1A] border border-[#1E2A3A] p-8 rounded-sm hover:border-[#C9A84C]/40 transition-all duration-300 group">
                <div className="w-12 h-12 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm mb-6 group-hover:border-[#C9A84C] transition-colors">
                  <i className={`${cap.icon} text-[#C9A84C] text-xl`}></i>
                </div>
                <div className="flex items-baseline gap-1 mb-1">
                  <span className="text-[#C9A84C] font-black" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(36px, 4vw, 52px)", letterSpacing: "0.02em" }}>
                    {cap.value}
                  </span>
                  {cap.unit && (
                    <span className="text-[#C9A84C]/70 font-bold text-lg">{cap.unit}</span>
                  )}
                </div>
                <h3 className="text-white font-bold text-base mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>{cap.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{cap.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── БЛОК 5: POP-отчёт — горизонтальный баннер с акцентом ── */}
      <section className="bg-[#060A10] py-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-0 border border-[#C9A84C]/25 rounded-sm overflow-hidden">
            {/* Left — gold accent block */}
            <div className="bg-[#C9A84C] p-10 flex flex-col justify-center">
              <div className="text-[#0A0F1A] text-[10px] font-black tracking-[0.3em] uppercase mb-3">Гарантия прозрачности</div>
              <div className="text-[#0A0F1A] font-black leading-none mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4vw, 52px)", letterSpacing: "0.03em" }}>
                PROOF OF<br />PRODUCT<br />(POP)
              </div>
              <div className="w-12 h-[2px] bg-[#0A0F1A]/40 mb-4"></div>
              <p className="text-[#0A0F1A]/80 text-sm leading-relaxed font-medium">
                Фото/видео отчёт с вашим персональным идентификатором — до оплаты основного инвойса.
              </p>
            </div>
            {/* Middle — description */}
            <div className="bg-[#0D1420] p-10 flex flex-col justify-center border-t lg:border-t-0 lg:border-l border-[#C9A84C]/20">
              <h3 className="text-white font-bold text-xl mb-4" style={{ fontFamily: "'Oswald', sans-serif" }}>
                Никаких авансов вслепую
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                Перед оплатой основного инвойса мы предоставляем полный фото/видео отчёт о готовности товара на складе. Вы видите реальный товар с вашим персональным идентификатором на упаковке.
              </p>
              <div className="flex flex-col gap-3">
                {[
                  "Фото каждого поддона с маркировкой",
                  "Видео обхода склада с вашим заказом",
                  "Подтверждение Честный ЗНАК и EAC",
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full flex-shrink-0"></div>
                    <span className="text-gray-300 text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Right — CTA */}
            <div className="bg-[#080C14] p-10 flex flex-col justify-center items-start border-t lg:border-t-0 lg:border-l border-[#C9A84C]/20">
              <div className="text-gray-500 text-xs tracking-[0.2em] uppercase mb-6">Запросить отчёт</div>
              <div className="text-white font-black mb-2" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(28px, 3vw, 42px)", letterSpacing: "0.03em" }}>
                ГОТОВЫ<br />ПОКАЗАТЬ<br />ПРЯМО СЕЙЧАС
              </div>
              <p className="text-gray-500 text-sm mb-8 leading-relaxed">
                Свяжитесь с нами — мы организуем POP-отчёт по вашему запросу в течение 24 часов.
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-8 py-4 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-camera-line text-base"></i>
                Запросить POP-отчёт
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
